import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a87d2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-inline-block" }

import FeatherIcon from "@/components/atoms/other/FeatherIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'AttendanceButton',
  props: {
  isAttendance: {
    type: Boolean,
    default: false
  },
  isDisabled: {
    type: Boolean,
    default: false
  }
},
  emits: ["click-attendance"],
  setup(__props, { emit: emits }) {

const props = __props;





function onClick() {
  emits("click-attendance", props.isAttendance);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["attendance-button", [
        { 'attendance-button--on': __props.isAttendance },
        { 'attendance-button--disabled': __props.isDisabled }
      ]]),
      onClick: onClick
    }, [
      _createVNode(FeatherIcon, { icon: "maximize" }),
      _createTextVNode(_toDisplayString(__props.isAttendance ? "退勤" : "出勤"), 1)
    ], 2)
  ]))
}
}

})